export enum ShippingProvider {
  Dhl = 'dhl',
  Fedex = 'fedex',
  Ups = 'ups',
  Usps = 'usps',
}

export function toShippingProvider(value: string): ShippingProvider | null {
  switch (value) {
    case ShippingProvider.Dhl:
      return ShippingProvider.Dhl;
    case ShippingProvider.Fedex:
      return ShippingProvider.Fedex;
    case ShippingProvider.Ups:
      return ShippingProvider.Ups;
    case ShippingProvider.Usps:
      return ShippingProvider.Usps;
    default:
      return null;
  }
}

export type ShippingAccountValidation = {
  valid: boolean;
  message: string | null;
};

export function validateShippingAccount(
  raw: string,
  provider: ShippingProvider
): ShippingAccountValidation {
  const trimmed = raw.trim();
  if (trimmed.length === 0) {
    return { valid: false, message: 'Account number is required.' };
  }

  switch (provider) {
    case ShippingProvider.Fedex:
    case ShippingProvider.Dhl:
      if (trimmed.length !== 9) {
        return {
          valid: false,
          message: 'FedEx and DHL account numbers must be exactly 9 digits.',
        };
      }
      if (!/^\d{9}$/.test(trimmed)) {
        return {
          valid: false,
          message: 'FedEx and DHL account numbers must be numerical.',
        };
      }
      return { valid: true, message: null };

    case ShippingProvider.Ups:
      if (trimmed.length !== 6) {
        return {
          valid: false,
          message: 'UPS account numbers must be exactly 6 characters.',
        };
      }
      if (!/^[a-z0-9]+$/i.test(trimmed)) {
        return {
          valid: false,
          message: 'UPS account numbers may only contain letters and numbers.',
        };
      }
      return { valid: true, message: null };

    case ShippingProvider.Usps:
      if (!/^[a-z0-9]+$/i.test(trimmed)) {
        return {
          valid: false,
          message: 'USPS account numbers may only contain letters and numbers.',
        };
      }
      return { valid: true, message: null };

    default:
      return { valid: true, message: null };
  }
}
